import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { mapIcon, LANDSALE_LOGO, condoImage } from "../../assets";
import { CHAIN, PLOT_STATUS } from "../../utils/constants/config";
import CustomLoader from "../../layout/CustomLoader.js";
import "./Modal.css";

const customStyles = {
  content: {
    height: "500px",
    background: "#000000",
  },
};

const ModalInventoryDetail = ({ inventory, showDetail, closeModal }) => {
  const [image_loader, setImageLoader] = useState(true);
  const counter = useRef(0);
  const resources = inventory?.metadata?.Resources?.split(",");

  // To hide owner address
  const hideChar = (str) => {
    if (str) {
      str = str?.split("@")[0];

      return str.length > 6
        ? str?.slice(0, 6) + str?.slice(-10).replace(/.(?=...)/g, "*")
        : str;
    }
  };

  const imageLoaded = () => {
    counter.current += 1;
    setImageLoader(false);
  };
  const URLViewImage = inventory?.plot_id
    ? inventory?.size
      ? `${process.env.REACT_APP_VLAND_ASSETS_PATH}plot-image-for-monster-zone/` +
        inventory?.size?.charAt(0).toUpperCase() +
        inventory?.size?.slice(1).toLowerCase() +
        ".png"
      : LANDSALE_LOGO
    : condoImage;
  const URLViewImageTwo = inventory?.image ? inventory?.image : LANDSALE_LOGO;

  const blockchainURL = () => {
    if (inventory?.blockchain === "CARDANO") {
      const id = inventory?.plot_id ?? inventory?.id;

      return (
        process.env.REACT_APP_CARDANO_TRANSACTION_HASH_LINK +
        process.env.REACT_APP_CARDANO_POLICY_ID_HEX +
        Buffer.from(id + "", "utf8").toString("hex")
      );
    } else {
      return `${process.env.REACT_APP_BLOCKCHAIN_URL}${
        process.env.REACT_APP_NFT_CONTRACT_ADDRESS
      }?a=${inventory?.plot_id ?? inventory?.id}`;
    }
  };

  return (
    <>
      <Modal
        show={showDetail}
        style={customStyles}
        animation={false}
        dialogClassName="modal-dialog modal-dialog-centered"
        contentClassName={`customPopup inventoryDetail inboxInventory ${
          inventory?.condo_id ? "condoTower" : ""
        }`}
        size="xl"
      >
        <button type="button" className="close" onClick={closeModal}></button>

        <div className="content inventoryCol">
          <div className="row">
            <div className="col-sm-12 column">
              <div className="plotImg">
                <div
                  id="carouselExampleIndicators"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div
                    className={`carousel-indicators ${
                      inventory?.condo_id && "d-none"
                    }`}
                  >
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="0"
                      className="active "
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleIndicators"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                  </div>
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="imgHolderMain clr condoTower">
                        {image_loader && <CustomLoader />}
                        <img
                          src={URLViewImage}
                          alt=""
                          onLoad={imageLoaded}
                          onClick={() => window.open(URLViewImage, "_blank")}
                          style={{
                            display: !image_loader ? "block" : "none",
                            maxWidth: "100%",
                          }}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div
                      className={`carousel-item ${
                        inventory?.condo_id && "d-none"
                      }`}
                    >
                      <div className="imgHolderMain clr">
                        <img
                          src={URLViewImageTwo}
                          alt="Plot Image"
                          onLoad={imageLoaded}
                          onClick={() => window.open(URLViewImageTwo, "_blank")}
                          style={{
                            display: !image_loader ? "block" : "none",
                            maxWidth: "100%",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 offsetColumn">
              <div className="plotInfo">
                <div className="topInfo">
                  <h2 className="title title-sm">
                    {inventory?.plot_name ?? inventory?.name}
                  </h2>
                  <div className="grid">
                    <div className={`plotCard`}>
                      <span>{inventory?.plot_id ? "Plot ID" : "Condo ID"}</span>
                      <label htmlFor="">
                        {inventory?.plot_id ?? inventory?.condo_id}
                      </label>
                    </div>
                    <div
                      className={`plotCard ${
                        inventory?.status == "SOLD" ? "" : "d-none"
                      }`}
                    >
                      <span>{inventory?.plot_id ? "Rarity" : "Floor#"}</span>
                      <span>
                        {inventory?.plot_id
                          ? inventory?.rarity
                          : inventory?.floor_no}
                      </span>
                    </div>
                  </div>
                </div>

                <ul className="listing">
                  {inventory?.status == "SOLD" && inventory?.condo_no && (
                    <li>
                      <h4>Condo No</h4>
                      <p className="truncate">{inventory?.condo_no}</p>
                    </li>
                  )}

                  <li>
                    <h4>Current Owner</h4>
                    <p className="truncate">{hideChar(inventory?.owner_id)}</p>
                  </li>
                  <li>
                    <h4>Transaction Status</h4>
                    <p className="status confirm">
                      {inventory?.status == "SOLD" ? "Confirmed" : "Processing"}
                    </p>
                  </li>
                  <li>
                    <div>Blockchain</div>
                    <p>
                      {inventory?.blockchain == CHAIN.CARDANO
                        ? "Cardano"
                        : "Ethereum"}
                    </p>
                  </li>
                </ul>

                <div className="bottomInfo">
                  <a href={blockchainURL()} className="link" target={"_blank"}>
                    Blockchain View
                  </a>
                  <div className="location">
                    <img src={mapIcon} alt="" />
                    <span className="place">Monster Zone</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`col-sm-12 col-md-12 col-lg-12 ${
              inventory?.status == PLOT_STATUS.SOLD && inventory?.plot_id
                ? ""
                : "d-none"
            }`}
          >
            <div className="plotResources">
              <h4>Resources</h4>
              <ul className="materials">
                {resources &&
                  resources.map((resource, i) => (
                    <li key={i}>
                      <div className="resourceImg">
                        <img
                          // onClick={handleFullView}
                          src={`${
                            process.env.REACT_APP_VLAND_ASSETS_PATH
                          }resources/${resource.replace(/\s+/g, "")}.png`}
                          alt={resource}
                          className="img-fluid"
                        />
                      </div>
                      <p>{resource}</p>
                    </li>
                  ))}
              </ul>
            </div>

            <ul className="plotDetails">
              <li>
                <h4>Land Bot slots</h4>
                {inventory?.metadata && inventory?.metadata["Robot Slots"]}
              </li>
              <li>
                <h4>NPC Slots</h4>
                {inventory?.metadata && inventory?.metadata["NPC Slots"]}
              </li>
              <li>
                <h4>Game Cubes</h4>
                <div className="slots">
                  {inventory?.metadata && inventory?.metadata["Game Cube"]}
                </div>
              </li>
              <li>
                <h4>Relics</h4>
                <div className="slots">{inventory?.metadata?.Relics}</div>
              </li>
              <li>
                <h4>Loot Boxes</h4>
                <div className="slots">
                  {inventory?.metadata && inventory?.metadata["Loot Box"]}
                </div>
              </li>
            </ul>
          </div>
          <div className="mobile-btn">
            <button onClick={closeModal} className="custom-btn gray-bg lg">
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ModalInventoryDetail;
